var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { INCOME_UPDATE_SCHEMA } from "../ui/templates/IncomeCaptureModal/incomeCaptureSchema";
export var IncomeCaptureFormProvider = function (_a) {
    var children = _a.children;
    var methods = useForm({
        defaultValues: { income: "" },
        mode: "onBlur",
        resolver: zodResolver(INCOME_UPDATE_SCHEMA),
    });
    return _jsx(FormProvider, __assign({}, methods, { children: children }));
};
